import styled, { css } from 'styled-components';
import Button from '../Button';

export const ButtonHeader = styled.button<{ active?: boolean }>`
  ${({ active = false }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${active ? '#364856' : '#D9D9D9'};
    color: ${active ? 'white' : '#364856'};
    border-radius: 6px;
    border: none;
    font-weight: bold;
    height: 25px;
    margin-left: 10px;
    margin-top: 7px;
    height: 40px;
    width: 238px;
    margin-bottom: 5px;
    font-size: 16px;
    &:hover {
      background: ${active ? '#364856' : '#cccccc'};
    }
    &:active {
      background: ${active ? '#364856' : '#bebebe'};
    }
  `}
`;

export const PrevIcon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const LogoHeaderGrey = styled.img`
  height: 30px;
  width: 90px;
  margin: auto 15px;
`;

export const VoltarHeaderGrey = styled.img`
  height: 20px;
  width: 22px;
  margin-top: 5px;
`;

export const SinoHeaderGrey = styled.img`
  height: 18px;
  width: 18px;
`;

export const CriarEditarCartaz = styled.img`
  width: 30px;
  height: 28px;
  margin-right: 20px;
`;

export const Boxul = styled.div`
  display: flex;
  width: 110px;
  gap: 12px;
  justify-content: center;
  align-items: center;
`;

export const ContaHeaderGrey = styled.img`
  height: 18px;
  width: 18px;
`;

export const ConfiguracaoHeaderGrey = styled.img`
  height: 18px;
  width: 18px;
`;

export const UsuarioSpan = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #364856;
  margin-left: 10px;
`;
